import { render, staticRenderFns } from "./BKBracket.vue?vue&type=template&id=184b2149&scoped=true"
import script from "./BKBracket.vue?vue&type=script&lang=js"
export * from "./BKBracket.vue?vue&type=script&lang=js"
import style0 from "./BKBracket.vue?vue&type=style&index=0&id=184b2149&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184b2149",
  null
  
)

export default component.exports